<div class="otp-container">
    <input id="otp-input-1" type="text" (keyup)="onKeyUp(1, $event)" maxlength="1"/>
    <input id="otp-input-2" type="text" (keyup)="onKeyUp(2, $event)" maxlength="1"/>
    <input id="otp-input-3" type="text" (keyup)="onKeyUp(3, $event)" maxlength="1"/>
    <input id="otp-input-4" type="text" (keyup)="onKeyUp(4, $event)" maxlength="1"/>
    <input id="otp-input-5" type="text" (keyup)="onKeyUp(5, $event)" maxlength="1"/>
    <input id="otp-input-6" type="text" (keyup)="onKeyUp(6, $event)" maxlength="1"/>
</div>